import * as React from 'react'

export const SvgIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    style?: React.CSSProperties
  },
) => <svg aria-hidden={true} {...props}></svg>
export default SvgIcon
